var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeppoLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.903,
    height: 28.684,
    viewBox: "0 0 126.903 28.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-184 241.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,0,0,0,11.474H0V28.684s3.479,0,3.479-2.957V20.438A12,12,0,1,0,12,0Zm0,20.511A8.516,8.516,0,1,1,20.511,12,8.516,8.516,0,0,1,12,20.511Z",
    transform: "translate(184 -241.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.665,0a12,12,0,0,0-12,11.474h0V28.684s3.473,0,3.473-2.957V20.438A12,12,0,1,0,110.665,0Zm0,20.511A8.516,8.516,0,1,1,119.181,12a8.516,8.516,0,0,1-8.516,8.516Z",
    transform: "translate(136.789 -241.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,0a12,12,0,0,0-12,11.474h0V28.684s3.479,0,3.479-2.957V20.438A12,12,0,1,0,160,0Zm0,20.511A8.516,8.516,0,1,1,168.511,12,8.516,8.516,0,0,1,160,20.511Z",
    transform: "translate(113.186 -241.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.325,0a12,12,0,1,0,12,12A12,12,0,0,0,209.325,0Zm0,20.511a8.516,8.516,0,1,1,8.522-8.519,8.516,8.516,0,0,1-8.522,8.519Z",
    transform: "translate(89.583 -241.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.33,8.33a5.655,5.655,0,0,1,4,4.694h1.215A6.258,6.258,0,0,0,75.33,8.33Z",
    transform: "translate(147.957 -245.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.327,0A12,12,0,1,0,72.134,17.211H68.055a8.511,8.511,0,0,1-15.067-3.479H73.2A12,12,0,0,0,61.327,0Zm-.448,3.385a1.148,1.148,0,0,1-.414-.855.871.871,0,1,1,1.737,0,1.148,1.148,0,0,1-.414.855,8.443,8.443,0,0,1,7.885,6.524H52.983a8.454,8.454,0,0,1,7.9-6.524Zm6.5,7.395h-12.1c-.73,0-2.295-.35-2.295-.7h16.69C69.672,10.43,68.629,10.78,67.381,10.78Z",
    transform: "translate(160.394 -241.59)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeppoLogoWhite);
export default __webpack_public_path__ + "static/media/Peppo_logo_white.49d25dca0316faadd46f3aec73a80a24.svg";
export { ForwardRef as ReactComponent };